module.exports = __webpack_public_path__ + "img/89.c6a7c15a.jpg";